import { createParser } from 'eventsource-parser';
import { getServerPath } from 'infrastructure/js/utils/appHelper';
import Network from 'infrastructure/js/modules/network';


export function fetchAiAgentPreferences() {
  return Network.get('ai/chatbot/preferences');
}
export function setAiAgentPreferences(data) {
  return Network.put('ai/chatbot/preferences', data);
}

export function fetchAiAgentFeedbacks(data) {
  return Network.get(`ai/chatbot/feedbacks?userId=${data.userId}&sessionId=${data.sessionId}`);
}

export function setAiAgentFeedback(data) {
  return Network.post('ai/chatbot/feedback', data);
}

// /**
//  * @param {{
//  *   prompt: string,
//  *   sessionId: string,
//  *   onChunk: (text: string) => void,
//  *   onDone: () => void,
//  *   onError: (err: Error) => void,
//  * }} params
//  */
// export async function sendMessageStream({ prompt, sessionId, onChunk, onDone, onError }) {
//   const serverPath = getServerPath();

//   let response;
//   try {
//     response = await fetch(serverPath + 'ai/chatbot/invoke-stream', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       credentials: 'include',
//       body: JSON.stringify({ prompt, sessionId }),
//     });
//   } catch (err) {
//     onError(err);
//     return;
//   }

//   if (!response.ok) {
//     onError(new Error(`Server error: ${response.status}`));
//     return;
//   }

//   const reader = response.body.getReader();
//   const decoder = new TextDecoder();
//   let streamDone = false;

//   const parser = createParser({
//     onEvent: (event) => {
//       if (event.data === '[DONE]') {
//         streamDone = true;
//         onDone();
//         return;
//       }
//       onChunk(event.data);
//     },
//   });

//   try {
//     while (true) {
//       const { done, value } = await reader.read();

//       if (done || streamDone) {
//         if (!streamDone) {
//           onDone();
//         }
//         break;
//       }

//       parser.feed(decoder.decode(value, { stream: true }));
//     }
//   } catch (err) {
//     onError(err);
//   }
// }



/**
 * @param {{
 *   prompt: string,
 *   sessionId: string,
 *   onChunk: (text: string) => void,
 *   onStatus: (message: string) => void,
 *   onDone: () => void,
 *   onError: (err: Error) => void,
 * }} params
 */
export async function sendMessageStream({ prompt, sessionId, onChunk, onStatus, onDone, onError }) {
  const serverPath = getServerPath();

  // // DEV - Test streaming UI with simulated delay and data. Remove this block for production.
  // await new Promise((resolve) => setTimeout(resolve, 20_000)); // Simulate network delay for testing.
  // onError(err);
  // return;


  let response;
  try {
    response = await fetch(serverPath + 'ai/chatbot/invoke-stream', {
    // response = await fetch(serverPath + 'ai/chatbot/invoke-stream-test', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ prompt, sessionId }),
    });
  } catch (err) {
    onError(err);
    return;
  }

  if (!response.ok) {
    onError(new Error(`Server error: ${response.status}`));
    return;
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let streamDone = false;

  const parser = createParser({
    onEvent: (event) => {
      if (event.data === '[DONE]') {
        streamDone = true;
        onDone();
        return;
      }
      try {
        const parsed = JSON.parse(event.data);
        if (parsed.type === 'status') {
          onStatus(parsed.message);
          return;
        }
        if (parsed.type === 'token') {
          onChunk(parsed.text);
          return;
        }
        // Backward compat: {"token": "..."}
        onChunk(parsed.token ?? event.data);
      } catch {
        onChunk(event.data);
      }
    },
  });

  try {
    while (true) {
      const { done, value } = await reader.read();

      if (done || streamDone) {
        if (!streamDone) {
          onDone();
        }
        break;
      }

      parser.feed(decoder.decode(value, { stream: true }));
    }
  } catch (err) {
    onError(err);
  }
}

